import React from 'react';
import { BrokerShortDetails } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import labeledItemStyle from 'acscp/components/common/labeledItem.module.scss';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { TelephoneLink } from 'acscp/components/common/telephoneLink';
import style from 'acscp/components/itinerary/sharedItinerary.module.scss';
import { ContactInfo } from './contactInfo';

interface AcsContactsProps {
    accountManager: BrokerShortDetails | null;
    flightManager: BrokerShortDetails | null;
}
const AcsContactsContent: React.SFC<AcsContactsProps> = ({accountManager, flightManager}) => {
    if (accountManager === null && flightManager === null) {
        return null;
    }

    const office24HrNumber = accountManager
        ? accountManager.office24HrNumber
        : flightManager && flightManager.office24HrNumber;

    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                <ContactInfo
                    contact={accountManager}
                    title={
                        <FormattedMessage
                            id={'web.components.itinerary.acsContacts.accountManager'}
                            defaultMessage={'Account Manager'}
                        />
                    }
                />
                <ContactInfo
                    contact={flightManager}
                    title={
                        <FormattedMessage
                            id={'web.components.itinerary.acsContacts.flightManager'}
                            defaultMessage={'Flight Manager'}
                        />
                    }
                />
                {office24HrNumber &&
                    <div className={style.ItemContainerBordered}>
                        <div className={labeledItemStyle.Label}>
                            <FormattedMessage
                                id={'web.components.itinerary.acsContacts.24hrNumber'}
                                defaultMessage={'24/7 ACS Office Number'}
                            />
                        </div>
                        <div><TelephoneLink phoneNumber={office24HrNumber}/></div>
                    </div>
                }
            </div>
        </div>
    );
};

const AcsContacts = withCollapsable(
    (
        <Title>
            <FormattedMessage
                id={'web.components.itinerary.airCharterServiceContactsTitle'}
                defaultMessage={'AIR CHARTER SERVICE CONTACTS'}
            />
        </Title>
    ),
    AcsContactsContent);
export { AcsContacts };
